import { BaseClass } from './base'

export class AdClass extends BaseClass {
  modelRef = {
    title: '',
    adSlot: 0,
    adSlotName: '',
    imgUrl: '',
    activeStatus: 0,
    rank: 0,
    href: '',
    linkType: 0,
    linkName: ''
  }

  rulesRef = {
    title: [
      {
        required: true,
        message: '请输入标题'
      }
    ],
    adSlot: [
      {
        required: true,
        message: '请选择广告位'
      }
    ],
    imgUrl: [
      {
        required: true,
        message: '请选择图片'
      }
    ]
  }

  gets (params) {
    return this.get(this.ad, params)
  }

  create (data) {
    return this.post(this.ad, data)
  }

  update (data) {
    return this.put(this.ad, data)
  }

  del (id) {
    return this.delete(this.ad + `/${id}`)
  }

  active (id, sta) {
    return this.get(this.ad + `/SetActiveStatus/${id}/${sta}`)
  }
}

export class FeedbackClass extends BaseClass {
  gets (params) {
    return this.get('/api/Feedback', params)
  }

  handle (data) {
    return this.post('/api/Feedback/Handle', data)
  }
}
